import React from 'react'
import Page, {ErrorMessage} from 'Event/template/SimpleBlog/Login/Page'
import {ForgotPasswordProps} from 'auth/password'
import {useSimpleBlogTemplate} from 'Event/template/SimpleBlog'
import {useGuestVariables} from 'Event'
import Description from 'Event/auth/ForgotPassword/Description'
import EmailField from 'Event/auth/Login/EmailField'
import styled from 'styled-components'
import SubmitButton from 'Event/auth/ForgotPassword/SubmitButton'

export default function ForgotPassword(props: ForgotPasswordProps) {
  return (
    <Page isPreview={false}>
      <Content {...props} />
    </Page>
  )
}

export function Content(props: ForgotPasswordProps) {
  const {login} = useSimpleBlogTemplate()
  const v = useGuestVariables()

  if (props.resetLinkSent) {
    return (
      <Description aria-label="password reset link sent">
        {v(login.passwordReset.successMessage)}
      </Description>
    )
  }

  return (
    <>
      <Description>{v(login.passwordReset?.description)}</Description>
      <StyledForm onSubmit={props.onSubmit}>
        <EmailField {...props} />
        <ErrorMessage>{props.responseError?.message}</ErrorMessage>
        <SubmitButton {...props} />
      </StyledForm>
    </>
  )
}

const StyledForm = styled.form`
  width: 100%;
`
